// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  SERVER_URL: 'https://auth-t.paso.com.co/api/web/',
  SERVICE_URL: 'https://paso-eco-back-master-rtohfd.laravel.cloud/api/web/',
  CLIENT_ID: '12',
  pusher_id: 'EnterprisesId',
  pusher_key: 'EnterprisesApp',
  pusher_cluster: 'mt1',
  pusher_port: 443,
  pusher_host: 'socket-t.paso.com.co',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
